export default __webpack_public_path__ + "static/media/1866.d782fb53.png";